module.exports = __webpack_public_path__ + "img/notice-modal-ko-KR.7575bfde.png";